// angularjs-color-picker options: the native <input type="color"> opens cut or in the window corner in some browsers.
// Colors stay "#rrggbb" as the native input saved them. dynamicHue is off: for white or black the hue slider would be all white or black.
export const COLOR_PICKER_OPTIONS = {
    alpha: false,
    format: "hexString",
    case: "lower",
    swatchBootstrap: false,
    dynamicHue: false
};

// Only the round swatch (.color-picker-label), without the hex input
export const COLOR_PICKER_SWATCH_OPTIONS = Object.assign({}, COLOR_PICKER_OPTIONS, {swatchOnly: true});



// WEBPACK FOOTER //
// ./sources/constants/color-picker.constant.js